import { reactive } from "vue";
import { TabsType } from "./flow-status-tabs.interface";
export const projectPaths = [];
export const flowStatusArr = reactive<TabsType[]>([
  {
    code: 'all',
    name: "全部",
    count:0
  },{
    code: "dtj",
    name: "待提交",
    count:0
  },
  {
    code: "spz",
    name: "审批中",
    count:0
  },
  {
    code: "ycx",
    name: "已撤销",
    count:0
  },
  {
    code: "sptg",
    name: "已通过",
    count:0
  },
  {
    code: "spbtg",
    name: "未通过",
    count:0
  },
 
  {
    code: "hsz",
    name: "回收站",
    count:0
  },
  {
    code: "yzf",
    name: "已作废",
    count:0
  },
  {
    code: "bgz",
    name: "变更中",
    count:0
  },
]);

